import { Flex } from '@mantine/core';
import { useCallback, useContext } from 'react';
import { SidebarContext } from '../../containers/side-bar/side-bar.context';
import { useGlobalStore } from '../../store/global-store/global-store';
import { setOrganization, setPortfolio } from '../../store/global-store/global-store.actions';
import { setSearchTerm, setSelectedInitiative } from '../../store/strategy-store/strategy-store.actions';
import { Select } from '../../ui-library/select/select';
import { icons } from './assets';

type Props = {
  enableTooltips: boolean;
};

export function GlobalScope({ enableTooltips }: Props) {
  const { sidebarOpen } = useContext(SidebarContext);

  const { organization, portfolio, organizations, portfolios } = useGlobalStore();

  const getOrganizationOptions = useCallback(
    () => organizations.map(({ id, name }) => ({ value: id, label: name })),
    [organizations],
  );

  const getPortfolioOptions = useCallback(() => {
    const filteredPortfolios = organization
      ? portfolios.filter((p) => p.organization.id === organization.id)
      : portfolios;
    return filteredPortfolios.map(({ id, name }) => ({ value: id, label: name }));
  }, [organization, portfolios]);

  return (
    <Flex direction="column" gap={16}>
      <Select
        data-bf="scope-select-organization"
        options={getOrganizationOptions()}
        value={organization?.id || null}
        onChange={(value: string) => {
          setOrganization(organizations.find((o) => o.id === value) || null);
          setPortfolio(portfolios.find((p: any) => p.organization.id === value) || null);
          setSelectedInitiative(null);
          setSearchTerm('');
        }}
        placeholder="Organization"
        enableTooltip={enableTooltips}
        searchable
        leftIcon={<img src={icons.iconOrganization} width={20} height={20} alt="Organization" />}
        disableChevron={!sidebarOpen}
      />
      <Select
        data-bf="scope-select-portfolio"
        options={getPortfolioOptions()}
        value={portfolio?.id || null}
        onChange={(value: string) => {
          const newPortfolio = portfolios.find((p: any) => p.id === value) || null;
          setPortfolio(newPortfolio);
          setSelectedInitiative(null);
          setSearchTerm('');
        }}
        placeholder="Portfolio"
        enableTooltip={enableTooltips}
        searchable
        leftIcon={<img src={icons.iconPortfolio} width={20} height={20} alt="Portfolio" />}
        disableChevron={!sidebarOpen}
      />
    </Flex>
  );
}
